import { ITurnedTextStyleSpecifiable, ITurnedTextStyle, TurnedTextFormatKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTurnedTextDrawable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class TurnedTextStyleTranslator {
  from(bean: IObjectBeanTurnedTextDrawable): ITurnedTextStyle {
    return {
      formatKind: this.formatKind.from(bean["@asterisk"]),
    };
  }

  to(object: ITurnedTextStyleSpecifiable) {
    return {
      asterisk: this.formatKind.to(object.turnedTextStyle.formatKind),
    };
  }

  private readonly formatKind = new MapTranslator<TurnedTextFormatKinds, string>([
    { object: TurnedTextFormatKinds.Asterisk, bean: "1" },
    { object: TurnedTextFormatKinds.Dot,      bean: "2" },
  ], TurnedTextFormatKinds.None, undefined);
}
